import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import forYouIcon from "../../assets/images/foryou.svg";

function Home() {
  const [product, setProduct] = useState([]);
  const [search, setSearch] = useState("");
  const [banner, setBanner] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const INITIAL_TIME = 366;
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME);
  const navigate = useNavigate();

  const [cart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // ✅ Bot detection (auto detect)
  const [isBot, setIsBot] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    const botKeywords = ["bot", "crawl", "spider", "slurp", "headless", "fetch"];
    const detectedBot = botKeywords.some((keyword) => ua.includes(keyword));
    setIsBot(detectedBot);
  }, []);

  useEffect(() => {
    fetch("/product-data.json")
      .then((res) => res.json())
      .then((data) => {
        const updatedProducts = data.map((p) => {
          const rating = (Math.random() * 1 + 4).toFixed(1);
          const reviews = Math.floor(1000 + Math.random() * 90000);
          return { ...p, rating, reviews };
        });
        setProduct(updatedProducts);
      });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev <= 1 ? INITIAL_TIME : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    fetch("/banner.json")
      .then((res) => res.json())
      .then((data) => {
        if (data[0]?.banner) {
          setBanner(data[0].banner);
        }
      })
      .catch((err) => console.error("Error loading banner:", err));
  }, []);

  useEffect(() => {
    if (!banner.length) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % banner.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [banner]);

  const filterProduct = product.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  const ProductCard = ({ product }) => {
    const hotDealText = product.hotDeal || "Hot Deal";
    const isHotDeal = hotDealText.trim().toLowerCase() === "hot deal";

    return (
      <Link
        to={`/ProductDetail/${product.id}`}
        className="product"
        style={{ textDecoration: "none", position: "relative" }}
      >
        {product.trending && (
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              backgroundColor: "#ff9100ff",
              color: "#fff",
              padding: "2px 6px",
              fontSize: "10px",
              fontWeight: "600",
              borderBottomRightRadius: "6px",
              zIndex: 10,
            }}
          >
            Trending
          </div>
        )}

        <div className="product-img">
          <div className="img-det">
            <div className="img-detail">
              <img
                src={product.mainimg}
                alt={product.name}
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = "/img/p-1.jpg";
                }}
              />
            </div>
          </div>
        </div>

        <div className="product-info" style={{ color: "black" }}>
          {product.name}
        </div>

        <div className="home-rating-row">
          <span className="home-rating-stars" aria-label={`${product.rating} out of 5 stars`}>
            ★★★★☆
          </span>
          <img src="/img/salec.png" alt="Assured" />
        </div>

        {!isBot ? (
          <div className="compact-price-row">
            <span className="compact-discount">
              <i className="fa-solid fa-arrow-down"></i>
              {product.dis} Off
            </span>
            <span className="compact-mrp">{product.total}</span>
            <strong className="compact-price">{product.disprice}</strong>
          </div>
        ) : (
          <div className="compact-price-row bot-price">{product.total}</div>
        )}

        <span className={isHotDeal ? "hot-deal-badge" : "hot-deal-text"}>
          {hotDealText}
        </span>
      </Link>
    );
  };

  return (
    <>
      <header id="header" className="home-header">
        <div className="container">
          <div className={`main-header home-main-header${isBot ? " bot-header" : ""}`}>
            <div className="home-brand-row" aria-label="Shopping destinations">
              <div className="home-brand home-brand-active">
                {isBot ? (
                  <span>ShopSmart</span>
                ) : (
                  <>
                    <img src="/img/flipkart-logo.webp" alt="" />
                    <span>Flipkart</span>
                  </>
                )}
              </div>
              <div className="home-brand home-travel-brand">
                <i className="fa-solid fa-plane" aria-hidden="true"></i>
                <span>Travel</span>
              </div>
            </div>

            <div className="home-search-row">
              <i className="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
              <input
                type="text"
                aria-label="Search for products"
                placeholder="Search for Product"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <button
                type="button"
                className="home-cart-button"
                aria-label={`Open cart${cart.length > 0 ? ` (${cart.length} items)` : ""}`}
                onClick={() => navigate("/cart")}
              >
                <i className="fa-solid fa-cart-shopping" aria-hidden="true"></i>
                {cart.length > 0 && (
                  <span className="header-cart">{cart.length}</span>
                )}
              </button>
            </div>

            <nav className="home-category-nav" aria-label="Shopping categories">
              <div className="home-category home-category-active">
                <img src={forYouIcon} alt="" />
                <span>For You</span>
              </div>
              <div className="home-category">
                <img src="/img/fashion.svg" alt="" />
                <span>Fashion</span>
              </div>
              <div className="home-category">
                <img src="/img/mobiles.svg" alt="" />
                <span>Mobiles</span>
              </div>
              <div className="home-category">
                <img src="/img/beauty.svg" alt="" />
                <span>Beauty</span>
              </div>
              <div className="home-category">
                <img src="/img/electronics.svg" alt="" />
                <span>Electronics</span>
              </div>
              <div className="home-category">
                <img src="/img/home.svg" alt="" />
                <span>Home</span>
              </div>
              <div className="home-category">
                <img src="/img/furniture.svg" alt="" />
                <span>Furniture</span>
              </div>
            </nav>
          </div>
        </div>
      </header>

      <main>
        <section className="banner-sec">
          <div className="container">
            <div className="slider-img">
              {banner.length > 0 && (
                <div className="banner-slider">
                  <div
                    className="banner-slides"
                    style={{
                      display: "flex",
                      transform: `translateX(-${currentIndex * 100}%)`,
                      transition: "transform 0.5s ease-in-out",
                    }}
                  >
                    {banner.map((img, index) => (
                      <div className="banner-slide" key={index}>
                        <img src={img} alt={`slide-${index}`} />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="deal-timer">
              <div className="timer">
                <h4>Deals of the Day</h4>
                <h3>{formatTime(timeLeft)}</h3>
              </div>
              <div className="time-sale">
                <button>SALE IS LIVE</button>
              </div>
            </div>
          </div>
        </section>

        <section className="cat-sec">
          <div className="container">
            <div className="pro-data">
              <div className="cat-link">
                {filterProduct.length > 0 ? (
                  filterProduct.map((p, index) => (
                    <ProductCard key={`${p.id}-${index}`} product={p} />
                  ))
                ) : (
                  <p>No Product Found</p>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Home;
